import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { Icon, Tappable } from '@vectord/components';
import {
  setBatchDetails,
  superBatchGroupModulesSelector,
} from 'features/satManagement';
// eslint-disable-next-line local-rules/invalid-import
import { useLazyGetCourseAssesmentBatchTimingsQuery } from '@satManagement/services/courseAssessmentMenteeService';
import styles from './ButtonToFetchBatcheDetails.module.scss';
import cogoToast from 'cogo-toast';

function ButtonToFetchBatchDetails() {
  const dispatch = useDispatch();
  const selectedSuperBatch = useSelector(superBatchGroupModulesSelector);
  const [fetchBatchDetails, { isFetching, error }] =
    useLazyGetCourseAssesmentBatchTimingsQuery();

  useEffect(() => {
    if (error) {
      cogoToast.error(error.data?.message || 'something went wrong');
    }
  }, [error]);

  const getDetails = useCallback(async () => {
    dispatch(setBatchDetails(null));
    try {
      const response = await fetchBatchDetails(
        { superBatchId: selectedSuperBatch?.id },
        true
      );
      dispatch(setBatchDetails(response.data));
    } catch (e) {
      cogoToast.error(e.message || 'something went wrong');
    }
  }, [dispatch, fetchBatchDetails, selectedSuperBatch?.id]);

  const handleOnClick = useCallback(() => {
    getDetails();
  }, [getDetails]);

  return (
    <Tappable
      onClick={handleOnClick}
      className={classNames(
        'btn btn-outlined btn-primary m-t-10 m-b-10',
        styles.root
      )}
      disabled={isFetching || !selectedSuperBatch?.id}
    >
      <Icon name="add" />
      Get Batch Details
    </Tappable>
  );
}

export default ButtonToFetchBatchDetails;
